module.exports = __webpack_public_path__ + "bbf5c076cb8cb9d90bda078508dba520.svg";